import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M28.393 13.895a130 130 0 0 0-.403 10.162q-.002 5.062.39 10.048C28.51 35.752 29.51 37 30.702 37h2.547C34.215 37 35 35.909 35 34.563V13.436c0-1.346-.784-2.437-1.75-2.437h-2.535c-1.19 0-2.19 1.248-2.32 2.895m4.606-.11c0-.433-.168-.785-.376-.785h-1.63c-.384 0-.706.603-.748 1.4a185 185 0 0 0-.255 9.656q-.002 4.809.247 9.544c.042.797.364 1.4.747 1.4h1.64c.207 0 .375-.352.375-.786zM9.124 11.512l15.232 9.52a3.5 3.5 0 0 1-.002 5.938L9.102 36.489a3 3 0 0 1-4.57-2.212Q3.997 29.472 4 24.063q.003-5.439.553-10.342a3 3 0 0 1 4.571-2.21m-1.479 1.55a1 1 0 0 0-1.105.883q-.536 4.79-.54 10.12-.003 5.3.52 9.99a1 1 0 0 0 1.523.737l15.252-9.519a1.5 1.5 0 0 0 0-2.544l-15.23-9.52a1 1 0 0 0-.42-.147m35.951.834q.4 5.08.403 10.162.002 5.062-.39 10.048c-.13 1.647-1.13 2.895-2.321 2.895H38.74c-.967 0-1.751-1.091-1.751-2.437V13.436c0-1.346.784-2.437 1.75-2.437h2.535c1.19 0 2.19 1.248 2.32 2.895m-4.606-.11c0-.433.168-.785.376-.785h1.63c.384 0 .706.603.748 1.4q.253 4.828.255 9.656.002 4.809-.247 9.544c-.042.797-.364 1.4-.747 1.4h-1.64c-.207 0-.375-.352-.375-.786z",
      clipRule: "evenodd"
    }
  )
);
var SvgPlayPauseOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlayPauseOutlined_default = SvgPlayPauseOutlined;

export { PlayPauseOutlined_default as default };
